import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import SolutionLibrary from "../../Components/Dashboard/SolutionLibrary/SolutionLibrary";
import Loader from "../../Components/Shared/Loader/loader";
import { useMsal } from "@azure/msal-react";
import WelcomeUser from "../../Components/Dashboard/Project/WelcomeUser";
import WorkspaceCreateProjectPage from "./Recommendation/WorkspaceCreateProjectPage";
import { AliceGPTContextProvider } from "../../Context/AliceGPT/AliceGPTContext";
import { useTranslation } from "react-i18next";
import { getUserAndItsOrganizations } from "../../API/Organization/organization";
import { postMessageToRuntime } from "../../Components/Helpers/Runtime/runtime";

export const WorkspacePage = (props) => {

    const params = useParams()
    const context = useMsal()

    const [state, setState] = useState({
        loading: true,
        showCreateProjectPage: false,
        organization: {},
        user: {},
        userRole: {},
        error: {
            isValid: true,
            type: "",
            message: ""
        }
    })

    const { i18n, ready: tReady } = useTranslation();

    const validateAccess = async () => {
        let error = {
            isValid: true,
            type: "",
            message: ""
        }
        let organization = {}
        let user = {}
        let userRole = {}
        const accessToken = localStorage.getItem("accessToken")
        if (!accessToken) {
            error.isValid = false
            error.type = "login"
            error.message = "You are not logged in"
        } else {
            let { organizations, user } = await getUserAndItsOrganizations(params.userEmail);
            organization = organizations.find(org => org._id === params.organizationId) || []
            const organizationUser = organization.users.find(u => u.userId === user._id)
            userRole = organization.roles.find(r => r._id === organizationUser.roleId)
            user = user || {}
            if (user._id === undefined) {
                error.isValid = false
                error.type = "user "
                error.message = "User not found"
            } else if (organization.length === 0) {
                error.isValid = false
                error.type = "organization"
                error.message = "No organization found for User"
            } else if (organization._id !== params.organizationId) {
                error.isValid = false
                error.type = "organization"
                error.message = "You do not have access to this organization"
            } else if (!organization.isActive) {
                error.isValid = false
                error.type = "organization"
                error.message = "Organization is not active anymore"
            }
        }
        setState(prevState => ({
            ...prevState,
            error,
            loading: false,
            user,
            organization,
            userRole: userRole || {}
        }))
    }

    const backToAppLibrary = () => {
        postMessageToRuntime({
            eventType: "PROJECT_NAME_CHANGED",
            value: ""
        })
        setState(prevState => ({
            ...prevState,
            showCreateProjectPage: false
        }))
    }

    useEffect(() => {
        validateAccess();
    }, [context]);

    useEffect(() => {
        if (tReady) {
            i18n.changeLanguage(state.organization.platformLanguage || "en");
        }
    }, [tReady, state.organization])

    if (state.loading) return <Loader />

    if (state.error.isValid === false && state.error.type === "subscription") {
        return (
            <WelcomeUser
                user={state.user}
                email={state.user.email}
            />
        )
    }

    if (state.error.isValid === false) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                <div class="alert alert-danger" userRole="alert">
                    {state.error.message}
                </div>
            </div>
        )
    }

    if (state.showCreateProjectPage) {
        return (
            <AliceGPTContextProvider>
                <WorkspaceCreateProjectPage
                    showBackButton={true}
                    backToAppLibrary={backToAppLibrary}
                    organization={state.organization}
                    user={state.user} />
            </AliceGPTContextProvider>
        )
    }

    return (
        <SolutionLibrary
            isShowFromRuntime={true}
            showCreateProjectPage={() => {
                setState(prevState => ({
                    ...prevState,
                    showCreateProjectPage: true
                }))
            }}
            user={state.user}
            userRole={state.userRole}
            organization={state.organization}
        />
    )
}